import { Trans, useLingui } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import { FiltersButton } from '@/design_system/Filters/FiltersButton/FiltersButton';
import { FiltersMenu } from '@/design_system/Filters/FiltersMenu/FiltersMenu';
import InputSearch from '@/design_system/InputSearch';
import Stack from '@/design_system/Stack';
import IconCross from '@/icons/Cross.svg';

import { useFilters } from '../FiltersState';

import { FiltersCarrier } from './FiltersCarrier';
import { FiltersDestination } from './FiltersDestination';
import { FiltersOrigin } from './FiltersOrigin';
import { FiltersStep } from './FiltersStep';

export const DesktopFilters = () => {
  const { t } = useLingui();
  const { search, activeFiltersCount, clearFilters } = useFilters();

  return (
    <Stack gap="0.75rem">
      <Stack row gap="1rem" alignItems="center">
        <FiltersMenu button={<FiltersButton />}>
          <FiltersStep />
          <FiltersCarrier />
          <FiltersOrigin />
          <FiltersDestination />
        </FiltersMenu>
        <InputSearch
          ariaLabel={t({ id: 'shipments.filters.search.label', message: 'Search shipments' })}
          placeholder={t({
            id: 'shipments.filters.search.placeholder',
            message: 'Search shipments...',
          })}
          value={search.search}
          onChange={search.debouncedSetSearch}
          style={{ flex: 1 }}
        />
      </Stack>

      {activeFiltersCount > 0 && (
        <Stack row gap="1rem" justifyContent="space-between" alignItems="center" flexWrap="nowrap">
          <Stack row gap="0.5rem">
            <FiltersStep tag />
            <FiltersCarrier tag />
            <FiltersOrigin tag />
            <FiltersDestination tag />
          </Stack>

          <Button
            variant="link-subtle"
            onPress={clearFilters}
            style={{ textWrap: 'nowrap' }}
            size="small"
          >
            <IconCross />
            <Trans id="shipments.filters.clear_all">Clear filters</Trans>
          </Button>
        </Stack>
      )}
    </Stack>
  );
};
